<template>
  <div>
    <div class="row text-brand-5 text-weight-bold q-mt-md">
      <div class="col-md-2">
        Solicitante:
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="filtros.solicitante"
        />
      </div>
      <div class="col-md-2 q-ml-sm">
        Data Inicial
        <q-input
          class="input-new-design"
          dense
          mask="##/##/####"
          outlined
          v-model="filtros.dataInicial"
          :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataInicial"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-md-2 q-ml-sm">
        Data Final
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="filtros.dataFinal"
          mask="##/##/####"
          :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataFinal"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>

      <div class="col-md-1 q-ml-sm q-mt-lg">
        <q-btn
          @click="getDados()"
          icon="filter_alt"
          no-caps
          style="background-color: #7ab9e0; border-radius: 8px; color: white"
          label="Filtrar"
        />
      </div>
    </div>

    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      dense
      :columns="columns"
      v-model:pagination="pagination"
      class="tabela-tamanho-fixo q-mt-md"
      row-key="name"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:no-data="props">
        <div
          v-if="props"
          style="background-color: transparent"
          class="full-width row flex-center q-gutter-sm q-mt-sm"
        >
          <q-img
            src="./../../../assets/tabelSemDados.svg"
            style="height: 170px; width: 150px"
          />
        </div>
      </template>
      <template #body-cell-url_assinada="props">
        <q-td>
          <q-btn
            @click="baixarArquivo(props.row)"
            round
            flat
            color="brand-1"
            icon="sym_o_download"
            :disable="!props.row.url_assinada"
          />
        </q-td>
      </template>
      <template #body-cell-nome_documento="props">
        <q-td>
          <span v-if="props.row.nome_documento">{{
            props.row.nome_documento
          }}</span>
          <q-icon
            v-if="props.row.erro"
            name="error"
            color="negative"
            size="sm"
            class="cursor-pointer q-ml-xs"
          >
            <q-tooltip
              max-width="350px"
              class="bg-negative text-white text-body2"
            >
              Erro: {{ props.row.erro }}
            </q-tooltip>
          </q-icon>
        </q-td>
      </template>
      <template #body-cell-updated_at="props">
        <q-td>
          <div>
            {{
              props.row.updated_at.split(" ")[0].split("-").reverse().join("/")
            }}
          </div>
          <div class="q-pl-sm">
            {{ props.row.updated_at.split(" ")[1] }}
          </div>
        </q-td>
      </template>
    </q-table>
    <div v-if="rows.length != 0" class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "tipo_documento",
    label: "Tipo Documento",
    field: "tipo_documento",
    align: "left",
  },
  {
    name: "usuario_nome",
    label: "Solicitante",
    field: "usuario_nome",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "nome_documento",
    label: "Nome Arquivo",
    field: "nome_documento",
    align: "left",
  },
  {
    name: "updated_at",
    label: "Criado Em",
    align: "left",
    field: "updated_at",
  },
  {
    name: "url_assinada",
    label: "Baixar",
    field: "url_assinada",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import { validarDataEmissao } from "../../../helpers/dateValidation";
export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const filtros = ref({
      dataInicial: "",
      dataFinal: new Date()
        .toLocaleString("pt-br")
        .split(" ")[0]
        .replace(",", " "),
      solicitante: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("ctd/getDownload", {
          data_inicial: filtros.value.dataInicial,
          data_final: filtros.value.dataFinal,
          pessoa: filtros.value.solicitante,
          page: page,
          per_page: rowsPerPage,
        });

        rows.value = response.data.result.data;

        pagination.value.rowsPerPage = response.data.result.per_page;
        pagination.value.rowsNumber = response.data.result.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    const baixarArquivo = async (row) => {
      const url = row.url_assinada;
      const nome = row.nome_documento || "download";

      if (nome.toLowerCase().endsWith(".txt")) {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = decodeURIComponent(nome);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        } catch {
          window.open(url, "_blank");
        }
      } else {
        window.open(url, "_blank");
      }
    };

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      validarDataEmissao,
      baixarArquivo,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
